import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PhoneIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6172 11.7949L13.3744 9.55204C12.5734 8.75103 11.2117 9.07146 10.8912 10.1127C10.6509 10.8337 9.84994 11.2342 9.12903 11.074C7.52701 10.6735 5.36428 8.59083 4.96378 6.90871C4.72348 6.18777 5.20408 5.38676 5.92499 5.14648C6.9663 4.82608 7.28671 3.46437 6.4857 2.66336L4.24287 0.42053C3.60206 -0.140177 2.64085 -0.140177 2.08015 0.42053L0.558229 1.94245C-0.963689 3.54447 0.718431 7.78982 4.48318 11.5546C8.24792 15.3193 12.4933 17.0816 14.0953 15.4795L15.6172 13.9576C16.1779 13.3168 16.1779 12.3556 15.6172 11.7949Z"
        fill="currentColor"
      />
    </svg>
  )
})

PhoneIcon.displayName = 'PhoneIcon'
